import { Card, CardContent } from "@/components/ui/card";

import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { formatDate } from "@/utils";
import {
	CheckCircleIcon,
	ExclamationCircleIcon,
	KeyIcon,
	LockOpenIcon,
	MinusCircleIcon,
	PauseIcon,
	PlayIcon,
	StatusOfflineIcon,
	StatusOnlineIcon,
} from "@heroicons/react/solid";
import { Flex, Icon } from "@tremor/react";

const UsersTable = ({
	users,
	deleteUser,
	pauseUser,
	resetPassword,
	unblockUser,
}: {
	users: any[];
	deleteUser: any;
	orgId: string;
	pauseUser: any;
	resetPassword: any;
	unblockUser: any;
}) => {
	// console.log("USERS: ", users);
	const handleDeleteClick = (e: React.MouseEvent, userId: number) => {
		e.stopPropagation();
		deleteUser(userId);
	};

	const handlePauseClick = (e: React.MouseEvent, userId: number, is_active) => {
		e.stopPropagation();
		pauseUser(userId, is_active);
	};

	const handleResetPasswordClick = (e: React.MouseEvent, userId: number) => {
		e.stopPropagation();
		resetPassword(userId);
	};

	const handleUnblockClick = (e: React.MouseEvent, userId: number) => {
		e.stopPropagation();
		unblockUser(userId);
	};

	return (
		<Card className="col-span-8">
			<CardContent className="px-0 pb-0">
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead className="max-w-[250px]">Χρήστης</TableHead>
							<TableHead className="max-w-[250px]">Ρόλος</TableHead>
							<TableHead className="max-w-[250px]">Χρ. Credits</TableHead>
							<TableHead className="max-w-[250px]">Λειτ.Σύστημα</TableHead>
							<TableHead className="max-w-[250px]">App Version</TableHead>
							<TableHead className="text-right">Ημερομηνία</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{users?.map(
							(
								org: {
									id: number;
									created_at: string;
									email: string;
									role: string;
									used_credits: number;
									is_active?: number;
									is_registered?: boolean;
									is_blackListed?: number;
									os?: string;
									version?: string;
									online?: boolean;
									inactive?: number;
								},
								index,
							) => (
								<TableRow key={`org-${index}`}>
									<TableCell className="font-medium">
										<Flex justifyContent="start">
											<Icon
												icon={MinusCircleIcon}
												color="red"
												className="button-delete cursor-pointer"
												onClick={(e) => handleDeleteClick(e, org.id)}
												tooltip="Διαγραφή Χρήστη"
											/>
											<Icon
												icon={KeyIcon}
												color="amber"
												className="button-delete cursor-pointer"
												onClick={(e) => handleResetPasswordClick(e, org.id)}
												tooltip="Επαναφορά Κωδικού"
											/>
											{org?.is_blackListed === 1 && (
												<Icon
													icon={LockOpenIcon}
													color="red"
													className="button-delete cursor-pointer"
													onClick={(e) => handleUnblockClick(e, org.id)}
													tooltip="Ξεμπλοκάρισμα Χρήστη"
												/>
											)}
											{org?.is_registered && (
												<Icon
													icon={CheckCircleIcon}
													color="emerald"
													className="button-delete"
													tooltip="Εγγραφή Ολοκληρωμένη"
												/>
											)}
											{!org?.is_registered && (
												<Icon
													icon={ExclamationCircleIcon}
													color="orange"
													className="button-delete"
													tooltip="Εγγραφή Εκρεμμεί"
												/>
											)}
											{org?.is_active === 1 && (
												<Icon
													icon={PlayIcon}
													color="blue"
													className="button-delete"
													tooltip="Ενεργός (Κλικάρετε για παύση)"
													onClick={(e) => handlePauseClick(e, org.id, false)}
												/>
											)}
											{org?.is_active !== 1 && (
												<Icon
													icon={PauseIcon}
													color="red"
													className="button-delete"
													tooltip="Σε παύση (Κλικάρετε για ενεργοποίηση)"
													onClick={(e) => handlePauseClick(e, org.id, true)}
												/>
											)}
											{org?.online ? (
												<Icon
													icon={StatusOnlineIcon}
													color="emerald"
													className="button-delete"
													tooltip="Online"
												/>
											) : (
												<Icon
													icon={StatusOfflineIcon}
													color="gray"
													className="button-delete"
													tooltip="Offline"
												/>
											)}
											{org?.email}
											{org?.inactive === 1 && ` - ανενεργός`}
										</Flex>
									</TableCell>
									<TableCell className="font-medium">{org?.role}</TableCell>
									<TableCell
										className={'font-medium'}
									>
										{org?.used_credits}
									</TableCell>
									<TableCell className="font-medium">
										{org?.os?.replace("|", " ")}
									</TableCell>
									<TableCell className="font-medium">{org?.version}</TableCell>
									<TableCell className="text-right">
										{formatDate(org.created_at, {
											simple: true,
											withTime: true,
										})}
									</TableCell>
								</TableRow>
							),
						)}
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
};

export default UsersTable;
